import { Component, Input } from '@angular/core';
import { TableColumn } from '../../models/irembo-data-table.model';

// Renders a customtablewithinputform field's read-only preview: the shared
// irembogov-data-table plus an "N item(s)" count row, both inside one
// seamless bordered box (the count row is NOT visually separate — see the
// component's scss for how it suppresses irembogov-data-table's own
// border/shadow so this reads as a single card, matching the design used
// across the review/summary pages).
@Component({
  selector: 'irembogov-table-with-input-preview',
  templateUrl: './table-with-input-item-count.component.html',
  styleUrls: ['./table-with-input-item-count.component.scss'],
})
export class TableWithInputItemCountComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];

  get count(): number {
    return this.data?.length ?? 0;
  }
}
